<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleClick(tableRow)">
              查看详情
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              placement="leftTop"
              ok-text="确定"
              cancel-text="取消"
              title="确定删除此信息?"
              @confirm="() => handleDel(tableRow.id)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a href="javascript:void(0)">
                删除
              </a>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, deleteRequest } from './api'

export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      tableLoading: true,
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    async handleDel(id) {
      try {
        await deleteRequest(id)
        this.$message.success('删除成功')
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      delete formData.pageSize

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },

    handleClick({ id }) {
      this.$router.push({ name: 'blacklist-details', params: { id,backType:2 } })
    },
  },
}
</script>

<style scoped lang="less">
.year-date {
  width: 100%;
}
</style>
